// Modul zur Erfassung eines Durchführungszeitraums
"use strict";

import module from "./module.js";
import "./vertraege.spec.js";

export default module;
